/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineIdentification, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useInfoContext } from "../../context/InfoContext";
import { pushOneAbout } from "../../lib/sysNavigation/SysNavigation";

type AboutRow = {
  about_us_id: number | string;
  mission?: string;
  vision?: string;
  goal?: string;
  objectives?: string;
  [key: string]: unknown;
};

const editRoute = "/about/edit";

const columns: Column<AboutRow>[] = [
  {
    header: "Section",
    cell: () => (
      <div className="flex flex-wrap gap-2">
        {["Mission", "Vision", "Goal", "Objectives"].map((label) => (
          <span
            key={label}
            className="inline-flex rounded-full bg-brand/5 px-2.5 py-1 text-[11px] font-medium text-brand ring-1 ring-inset ring-brand/15"
          >
            {label}
          </span>
        ))}
      </div>
    ),
  },
];

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { about, fetchAbout } = useInfoContext() as any;

  useEffect(() => {
    if (!about) fetchAbout();
  }, [about]);

  const rows = useMemo<AboutRow[] | null>(
    () => (about ? [about as AboutRow] : null),
    [about],
  );

  const rowActions = (row: AboutRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneAbout(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<AboutRow>
      title="About"
      subtitle="Mission, vision, goals, and objectives shown on the public site."
      icon={<HiOutlineIdentification className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.about_us_id}
      rowActions={rowActions}
      empty="No About content yet."
    />
  );
};

export default Overview;
